import axios from 'axios';

const API_URL = process.env.REACT_APP_SERVER_DOMAIN;

const createAuthHeaders = (token) => ({
  Authorization: `Bearer ${token}`,
});

export const searchMasterProducts = async (token, query, options = {}) => {
  const { data } = await axios.get(`${API_URL}/api/masterproducts/search`, {
    params: {
      q: query,
      category: options.category,
      brand: options.brand,
      limit: options.limit || 20
    },
    headers: createAuthHeaders(token)
  });
  return data;
};

export const getMasterProduct = async (token, id) => {
  const { data } = await axios.get(`${API_URL}/api/masterproducts/${id}`, {
    headers: createAuthHeaders(token)
  });
  return data;
};

export const matchProduct = async (token, productName, upc, brand) => {
  const { data } = await axios.post(
    `${API_URL}/api/masterproducts/match`,
    {
      product_name: productName,
      upc,
      brand
    },
    { headers: createAuthHeaders(token) }
  );
  return data;
};

export const autoLinkProducts = async (token, retailerId) => {
  const { data } = await axios.post(
    `${API_URL}/api/masterproducts/auto-link/${retailerId}`,
    {},
    { headers: createAuthHeaders(token) }
  );
  return data;
};

export const getCategories = async (token) => {
  const { data } = await axios.get(`${API_URL}/api/masterproducts/categories`, {
    headers: createAuthHeaders(token)
  });
  return data;
};

export const addProductFromMasterCatalog = async (token, retailerId, masterProductId, customData = {}) => {
  const { data } = await axios.post(
    `${API_URL}/api/products`,
    {
      retailer_id: retailerId,
      master_product_id: masterProductId,
      ...customData
    },
    { headers: createAuthHeaders(token) }
  );
  return data;
};
